const s = {
  name: "BrowserDevelopers",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,6.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2C4.3,3.8,3.8,4.3,3.8,5C3.8,5.7,4.3,6.3,5,6.3z"/>
		<path class="st0" d="M10.2,5c0,0.7-0.6,1.2-1.2,1.2C8.3,6.3,7.8,5.7,7.8,5c0-0.7,0.6-1.2,1.3-1.2C9.7,3.8,10.2,4.3,10.2,5z"/>
		<path class="st0" d="M13,6.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C11.7,5.7,12.3,6.3,13,6.3z"/>
		<path class="st0" d="M15.7,19.7l-1.4-1.4L8.6,24l5.7,5.7l1.4-1.4L11.4,24L15.7,19.7z"/>
		<path class="st0" d="M25.7,18.3l5.7,5.7l-5.7,5.7l-1.4-1.4l4.3-4.3l-4.3-4.3L25.7,18.3z"/>
		<path class="st0" d="M22.1,16.2L16,31l1.8,0.8L24,17L22.1,16.2z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M2,3v5h36V3
			c0-0.5-0.5-1-1-1H3C2.5,2,2,2.5,2,3z M2,10v27c0,0.5,0.5,1,1,1h34c0.5,0,1-0.5,1-1V10H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as BrowserDevelopers
};
